import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRegistration } from "../../../../interfaces/models/IRegistration";
import type { AppDispatch } from "../../../../redux/store";
import {
  patchRegistrationData,
  setRegistrationData,
} from "../../../../redux/states/editParticipant.state";
import {
  selectEventData,
  selectEventId,
  selectRegistrationData,
} from "../editParticipant.selectors";
import { createRegistrationDraft } from "../constants";

export function useEditParticipantPatch () {
  const dispatch = useDispatch<AppDispatch>();
  const eventId = useSelector(selectEventId);
  const eventData = useSelector(selectEventData);
  const registrationData = useSelector(selectRegistrationData);

  const patchRegistration = useCallback(
    (patch: Partial<IRegistration> & Record<string, unknown>) => {
      if (registrationData) {
        dispatch(patchRegistrationData(patch));
        return;
      }
      if (!eventId) {
        return;
      }
      dispatch(
        setRegistrationData({
          ...createRegistrationDraft(eventId, eventData),
          ...patch,
        }),
      );
    },
    [dispatch, eventData, eventId, registrationData],
  );

  return { patchRegistration };
}
